function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.118 12.664l12.044 6.732a2 2 0 010 3.492L17.118 29.62a2 2 0 01-2.976-1.746V14.409a2 2 0 012.976-1.745z",
  fill: "#434A54",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42"
  }, props), _ref);
};

export default SvgComponent;